import { z } from 'zod';
/** Journal demo-data slice — the authored journal days (SDD §7.4 "journal days") the Journal screen reads.
 *  Transcribed from the design reference JRN_DAYS (file lines 5066–5076 / script lines 1040–1050).
 *  Every field is deterministic, seeded and labeled simulated. */
export const JournalDaySchema = z
  .object({
    mood: z.string(),
    energy: z.number(),
    prep: z.string(), // pre-session note
    post: z.string(), // post-session review
    tags: z.array(z.string()),
    shots: z.number(), // screenshot count
  })
  .strict();
export const JournalDataSchema = z
  .object({
    /** Keyed by the reference jrnKey() form — 'YYYY-MM-DD' with a zero-based month ('2026-06-24' = 24 July 2026). */
    jrnDays: z.record(z.string(), JournalDaySchema),
  })
  .strict();
export type JournalDay = z.infer<typeof JournalDaySchema>;
export type JournalData = z.infer<typeof JournalDataSchema>;
